import { useContext } from 'react'
import { kClioAllowedOrgIds, kExternalStorageProvider, kIsExternalStorageProviderEnabled } from '@/constants/constants-external-storage'
import { AuthContext } from '@/context/auth-context'

/**
 * Whether the current user may see and connect Clio.
 *
 * Clio is a single-customer production pilot (Berenji Divorce & Family Law
 * Group, ENG-7047). In non-production environments the provider is enabled for
 * everyone by env mode; in production it is gated to an organization allowlist.
 * The gate keys off the `organization_id` JWT claim
 * (`legacyDriveCompatibleOrganizationId`) — the same value the backend enforces
 * on the Clio `/authorize` endpoint, so the two layers always agree.
 */
export default function useClioOrgAccess(): boolean {
  const { userAccountData } = useContext(AuthContext)

  // Non-prod: Clio is enabled for everyone via env mode.
  if (kIsExternalStorageProviderEnabled(kExternalStorageProvider.CLIO)) return true

  // Prod: only allowlisted organizations.
  const organizationId = userAccountData?.legacyDriveCompatibleOrganizationId
  return organizationId != null && kClioAllowedOrgIds.includes(organizationId)
}
